export default __webpack_public_path__ + "static/media/section34.302b0e7b.svg";